var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundOnLtr = function SvgSoundOnLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m57.959 88.59.493.416h-.493zm0 0V12l-26.63 21.785h-5.425c-1.973 0-3.452.506-4.931 2.026S19 38.851 19 40.877V60.13c0 2.026.986 3.546 1.973 5.066 1.48 1.013 3.452 2.027 4.931 2.027l7.89 1.013zm9.288-61.552a1.946 1.946 0 0 1 2.668-.79C78.603 31.118 84 40.41 84 50.5s-5.397 19.38-14.085 24.253a1.95 1.95 0 0 1-.945.247 1.96 1.96 0 0 1-1.726-1.04c-.524-.97-.177-2.189.776-2.723 7.432-4.164 12.049-12.111 12.049-20.737S75.45 33.927 68.022 29.761a2.025 2.025 0 0 1-.775-2.723"
  })));
};
export default SvgSoundOnLtr;